import { sharedProperty, useSharedState } from '../../../hooks';
import { BookingModel } from '../../../data/entities/booking/BookingModel';
import { BookingEventModel } from '../../../data/entities/booking/BookingEventModel';
import { trackServiceRemoved } from '../../../utils';

export const useBookingEvents = (booking: sharedProperty<BookingModel>) => {
  const showScheduleModalState = useSharedState<boolean>(false);
  const showConfirmModalState = useSharedState<boolean>(false);

  const handleDelete = (event: BookingEventModel) => {
    trackServiceRemoved(event);
    const updatedEvents = booking.value.bookingEvents.filter(
      (e) => e !== event
    );
    booking.setter({
      ...booking.value,
      bookingEvents: updatedEvents,
    });
  };

  return {
    showScheduleModalState,
    showConfirmModalState,
    handleDelete,
  };
};
